import { render, staticRenderFns } from "./RssFeedsMini.vue?vue&type=template&id=0bba49c6&"
import script from "./RssFeedsMini.vue?vue&type=script&lang=js&"
export * from "./RssFeedsMini.vue?vue&type=script&lang=js&"
import style0 from "./RssFeedsMini.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports